

import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { AddContainer, Component4, Texts, InputTextComponent, Component6, LabelWithTooltip } from './Styles';
import { getUserFromToken } from 'src/DecodeToken';
import SwitchComponent from 'src/components/shared/Form/Switch';
import NumberInput from 'src/components/shared/Form/Number';
import InputSelect from 'src/components/shared/Form/Select';
import { getStaffRequest } from 'src/modules/app/store/appActions';
import { useDispatch } from 'react-redux';
import storage from 'src/utils/storageUtils';



function ClinicSettingStep({ innerRef, data, setClinicProfileData, clinicId, onStepSubmitSuccess }) {
    const sanitizeNumber = (value) => {
        return value === '' || value === undefined || value === null ? 0 : Number(value);
    };

    const [staffOptions, setStaffOptions] = useState([]);
    const dispatch = useDispatch();

    const initialValues = {
        // id: data?.id || '',
        acceptingTokens: data?.acceptingTokens === "yes",
        automaticTaskAssignTo: data?.automaticTaskAssignTo || [],
        followUpTaskDays: data?.followUpTaskDays || 0,
        medicineReminderTask: data?.medicineReminderTask || false,
        treatmentSchedulingTask: data?.treatmentSchedulingTask || false,
        newCaseFollowUpTask: data?.newCaseFollowUpTask || false,
        associatedDoctors: data?.associatedDoctors || [],
        acceptingPatientReview: data?.acceptingPatientReview || false,
        establishmentYear: data?.establishmentYear || 0,
        consultingFees: data?.consultingFees || 0,
        oldCaseConsultingFees: data?.oldCaseConsultingFees || 0,
        caseValidityDays: data?.caseValidityDays || 0,
        emergencyFees: data?.emergencyFees || 0,
        appointmentBookingWindow: data?.appointmentBookingWindow || 0,
        minimumPriorBookingTime: data?.minimumPriorBookingTime || 0,
        patientIdPrefix: data?.patientIdPrefix || 'MYC',
    };

    useEffect(() => {
        const token = storage.get('TOKEN');
        const fetchData = async () => {
            const params = {
                clinicId: clinicId,
            };
            try {
                const response = await new Promise((resolve, reject) =>
                    dispatch(getStaffRequest({ token, params }, resolve, reject))
                );

                if (response?.data) {
                    const staffList = response.data;
                    const options = staffList.map((staff) => ({
                        label: staff.email,
                        value: staff.email,
                    }));

                    setStaffOptions(options);
                }
            } catch (error) {
                console.error('Failed to fetch staff data:', error);
                // Gracefully handle failure, e.g. empty staff list
                setStaffOptions([]);
            }
        };
        fetchData();
    }, []);

    const handleSubmit = (values) => {
        console.log("clinicsetting values", values)
        const formattedValues = {
            ...values,
            acceptingTokens: values.acceptingTokens ? "yes" : "no",
            followUpTaskDays: sanitizeNumber(values.followUpTaskDays),
            establishmentYear: sanitizeNumber(values.establishmentYear),
            consultingFees: sanitizeNumber(values.consultingFees),
            oldCaseConsultingFees: sanitizeNumber(values.oldCaseConsultingFees),
            caseValidityDays: sanitizeNumber(values.caseValidityDays),
            emergencyFees: sanitizeNumber(values.emergencyFees),
            appointmentBookingWindow: sanitizeNumber(values.appointmentBookingWindow),
            minimumPriorBookingTime: sanitizeNumber(values.minimumPriorBookingTime),
        };

        setClinicProfileData(prev => ({
            ...prev,
            clinicSetting: formattedValues
        }));
        onStepSubmitSuccess(formattedValues);
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            innerRef={innerRef}
            enableReinitialize={true}
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <Form>
                    <AddContainer>
                        <Component6>
                            <Texts>
                                <LabelWithTooltip
                                    label="Accepting Tokens"
                                    tooltip="Enable this option to allow token-based appointment scheduling."
                                />
                            </Texts>
                            <SwitchComponent
                                name="acceptingTokens"
                                checked={values.acceptingTokens}
                                onChange={() => setFieldValue('acceptingTokens', !values.acceptingTokens)}
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </Component6>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Automatic Task Assign To"
                                    tooltip="Select staff members to whom follow-up or reminder tasks will be auto-assigned."
                                />
                            </Texts>
                            <InputSelect
                                options={staffOptions}
                                name="automaticTaskAssignTo"
                                multiple
                                variant="outlined"
                                value={values.automaticTaskAssignTo}
                                onChange={(value) => setFieldValue('automaticTaskAssignTo', value)}
                                showNone={false}
                            />
                        </Component4>

                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="FollowUp TaskDays"
                                    tooltip="Number of days after consultation when a follow-up task should be triggered."
                                />
                            </Texts>
                            <NumberInput
                                name="followUpTaskDays"
                                fullWidth
                                width="auto" height="52px"
                                value={values.followUpTaskDays}
                                onChange={(values) => setFieldValue('followUpTaskDays', values)}
                            />
                        </Component4>
                        <Component6>
                            <Texts>
                                <LabelWithTooltip
                                    label="Medicine Reminder Task"
                                    tooltip="Enable this to send medicine intake reminders to patients."
                                />
                            </Texts>
                            <SwitchComponent
                                name="medicineReminderTask"
                                checked={values.medicineReminderTask}
                                onChange={() => setFieldValue('medicineReminderTask', !values.medicineReminderTask)}
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </Component6>
                        <Component6>
                            <Texts>
                                <LabelWithTooltip
                                    label="Treatment Scheduling Task"
                                    tooltip="Enable this to send reminders to schedule future treatments."
                                />
                            </Texts>
                            <SwitchComponent
                                name="treatmentSchedulingTask"
                                checked={values.treatmentSchedulingTask}
                                onChange={() => setFieldValue('treatmentSchedulingTask', !values.treatmentSchedulingTask)}
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </Component6>
                        <Component6>
                            <Texts>
                                <LabelWithTooltip
                                    label="New Case FollowUp Task"
                                    tooltip="Enable follow-up tasks automatically for new cases."
                                />
                            </Texts>
                            <SwitchComponent
                                name="newCaseFollowUpTask"
                                checked={values.newCaseFollowUpTask}
                                onChange={() => setFieldValue('newCaseFollowUpTask', !values.newCaseFollowUpTask)}
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </Component6>

                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Associated Doctors"
                                    tooltip="List of associated doctors. Separate multiple names with commas."
                                />
                            </Texts>
                            <InputTextComponent
                                name="associatedDoctors"
                                placeholder=""
                                variant="outlined"
                                value={values.associatedDoctors.join(', ')}
                                onChange={(e) =>
                                    setFieldValue('associatedDoctors', e.target.value.split(',').map(s => s.trim()))
                                }
                            />
                        </Component4>



                        <Component6>
                            <Texts>
                                <LabelWithTooltip
                                    label="Accepting Patient Review"
                                    tooltip="Enable this to allow patients to submit feedback or reviews."
                                />
                            </Texts>
                            <SwitchComponent
                                name="acceptingPatientReview"
                                checked={values.acceptingPatientReview}
                                onChange={() => setFieldValue('acceptingPatientReview', !values.acceptingPatientReview)}
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </Component6>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Establishment Year"
                                    tooltip="Enter the year your clinic or practice was established."
                                />
                            </Texts>
                            <NumberInput
                                name="establishmentYear"
                                fullWidth
                                width="auto" height="52px"
                                value={values.establishmentYear}
                                onChange={(values) => setFieldValue('establishmentYear', values)}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Consulting Fees"
                                    tooltip="Fee charged for consulting a patient with a new case."
                                />
                            </Texts>
                            <NumberInput
                                name="consultingFees"
                                fullWidth
                                width="auto" height="52px"
                                value={values.consultingFees}
                                onChange={(values) => setFieldValue('consultingFees', values)}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Old Case Consulting Fees"
                                    tooltip="Fee charged for consulting an existing (old) patient case."
                                />
                            </Texts>
                            <NumberInput
                                name="oldCaseConsultingFees"
                                fullWidth
                                width="auto" height="52px"
                                value={values.oldCaseConsultingFees}
                                onChange={(values) => setFieldValue('oldCaseConsultingFees', values)}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Case Validity Days"
                                    tooltip="Number of days a patient case remains valid before being treated as a new case."
                                />
                            </Texts>
                            <NumberInput
                                name="caseValidityDays"
                                fullWidth
                                width="auto" height="52px"
                                value={values.caseValidityDays}
                                onChange={(values) => setFieldValue('caseValidityDays', values)}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Emergency Fees"
                                    tooltip="Fee charged for emergency consultations outside normal hours."
                                />
                            </Texts>
                            <NumberInput
                                name="emergencyFees"
                                fullWidth
                                width="auto" height="52px"
                                value={values.emergencyFees}
                                onChange={(values) => setFieldValue('emergencyFees', values)}
                            />
                        </Component4>

                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Appointment Booking Window"
                                    tooltip="How many days in advance patients can book appointments."
                                />
                            </Texts>
                            <NumberInput
                                name="appointmentBookingWindow"
                                fullWidth
                                width="auto" height="52px"
                                value={values.appointmentBookingWindow}
                                onChange={(values) => setFieldValue('appointmentBookingWindow', values)}
                            />
                        </Component4>

                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Minimum Prior Booking Time (mins)"
                                    tooltip="Minimum time required before an appointment can be booked (in minutes)."
                                />
                            </Texts>
                            <NumberInput
                                name="minimumPriorBookingTime"
                                fullWidth
                                width="auto" height="52px"
                                value={values.minimumPriorBookingTime}
                                onChange={(values) => setFieldValue('minimumPriorBookingTime', values)}
                            />
                        </Component4>

                        <Component4>
                            <Texts>
                                <LabelWithTooltip
                                    label="Patient ID Prefix"
                                    tooltip="Prefix for auto-generated patient IDs (e.g., MYC, CLN, ABC)."
                                />
                            </Texts>
                            <InputTextComponent
                                name="patientIdPrefix"
                                fullWidth
                                variant="outlined"
                                value={values.patientIdPrefix}
                                onChange={handleChange}
                            />
                        </Component4>

                    </AddContainer>

                </Form>
            )}

        </Formik>
    );
}

export default ClinicSettingStep;
